<template>
  <div class="Nosotros">
    <div class="Acerca-box">
      <div class="Acerca">
        <div class="Acerca-title">Acerca de Nosotros</div>
        <div class="Acerca-desc">Aguila Information, S.A.P.I. de C.V..</div>
        <img src="@/assets/imgs/img18.png" class="img18" />
      </div>
      <img src="@/assets/imgs/img17.png" class="img17" />
    </div>
    <div class="Acerca-box">
      <img src="@/assets/imgs/img19.png" class="img19" />
      <div class="Acerca">
        <div class="Information">
          Introducción a Aguila Information, S.A.P.I. de C.V..
        </div>
        <div class="Information-desc">
          Aguila Information, S.A.P.I. de C.V.. es una empresa mexicana
          especializada en servicios financieros y tecnológicos, dedicada a
          ofrecer soluciones innovadoras y eficientes en el ámbito de los
          préstamos y la gestión de inversiones.
        </div>
      </div>
    </div>
    <div class="Acerca-box">
      <div class="Acerca">
        <div class="Information" style="text-align: left">Nuestra Misión</div>
        <div class="Information-desc" style="text-align: left">
          La misión de AGUILA INFORMATION es empoderar a las personas en México
          a través de soluciones financieras innovadoras y accesibles, rompiendo
          las barreras tradicionales del crédito y ayudando a nuestros clientes
          a alcanzar sus metas personales y profesionales.
        </div>
      </div>
      <img src="@/assets/imgs/img20.png" class="img20" />
    </div>
    <div class="page-title">Valores Fundamentales</div>
    <div class="card">
      <img src="@/assets/imgs/img22.png" />
      <div>
        <div class="card-title">Confianza y Transparencia</div>
        <div class="card-desc">
          En nuestros servicios financieros, la integridad y la transparencia
          son nuestros pilares. Nos comprometemos a operar con honestidad,
          evitando desinformación o prácticas ocultas. La transparencia se
          refleja en la presentación clara de cada tarifa, costo y condición
          contractual, para que nuestros clientes comprendan claramente cada
          detalle y confíen en que sus intereses son prioritarios, fomentando
          relaciones basadas en la confianza.
        </div>
      </div>
    </div>
    <div class="print-box">
      <div class="print">
        <div class="nei">
          <div class="nei-title">Servicios que Ofrecemos</div>
          <div class="nei-desc">
            AGUILA INFORMATION proporciona una amplia gama de servicios
            financieros, incluyendo
          </div>
        </div>
        <div class="info1">
          <div style="flex: 1">
            <div class="info-title">Préstamos Personales</div>
            <div class="info-desc">
              Ofrecemos soluciones de préstamos rápidos y flexibles para
              satisfacer las necesidades de nuestros clientes.
            </div>
          </div>
          <div class="num">01</div>
        </div>
        <div class="info2">
          <div class="num">02</div>
          <div style="flex: 1">
            <div class="info-title" style="text-align: left">
              Gestión de Inversiones
            </div>
            <div class="info-desc" style="text-align: left">
              Proporcionamos asesoramiento y gestión de inversiones
              profesionales para ayudar a nuestros clientes a aumentar el valor
              de sus activos.
            </div>
          </div>
        </div>
        <div class="info3">
          <div style="flex: 1">
            <div class="info-title">Soluciones FinTech</div>
            <div class="info-desc">
              Utilizamos plataformas tecnológicas avanzadas para ofrecer
              transacciones y servicios financieros eficientes.
            </div>
          </div>
          <div class="num">03</div>
        </div>
      </div>
    </div>
    <div class="Nuestra-box">
      <div class="Nuestra">
        <div class="Nuestra-title">Nuestra Visión</div>
        <div class="Nuestra-desc">
          AGUILA INFORMATION aspira a convertirse en la empresa FinTech líder en
          México, impulsando la transformación de la industria financiera a
          través de la innovación tecnológica y ofreciendo servicios financieros
          de mayor calidad y más accesibles a nuestros clientes.
        </div>
        <img src="@/assets/imgs/img23.png" class="img23" />
        <img src="@/assets/imgs/img24.png" class="img24" />
      </div>
    </div>
    <div class="Contanos">
      <div class="Contanos-title">Contáctanos</div>
      <div class="c-desc">
        <img src="@/assets/imgs/img28.png" class="img25" />
        <span>Correo electrónico</span>
        <span style="color: #fe953a">servicio@paay.mx</span>
      </div>
      <div class="c-desc Facebook">
        <img src="@/assets/imgs/img29.png" class="img25" />
        <span>Teléfono de contacto</span>
        <span style="color: #fe953a">+52 5564623367</span>
      </div>
      <div class="c-desc Av">
        <img src="@/assets/imgs/img30.png" class="img25" />
        <span>Dirección</span>
        <span style="color: #fe953a"
          >Insurgentes Sur 1248 Int. 498, Tlacoquemecatl, Benito Juárez, CDMX 03200</span
        >
      </div>
      <img src="@/assets/imgs/img25.png" class="img26" />
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Nosotros',
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.Acerca-box {
  padding: 78px 360px;
  display: flex;
  justify-content: space-between;
}
.Acerca {
  position: relative;
}
.Acerca-title {
  font-weight: bold;
  font-size: 50px;
  color: #000000;
  margin-bottom: 38px;
}
.Acerca-desc {
  font-weight: bold;
  font-size: 28px;
  color: #000000;
}
.img17 {
  width: 431px;
  height: 216px;
}
.img18 {
  width: 242.85px;
  height: 141.03px;
  position: absolute;
  right: -140px;
  bottom: 10px;
}
.img19 {
  width: 412px;
  height: 268px;
}
.Information {
  width: 699px;
  font-weight: bold;
  font-size: 40px;
  color: #000000;
  text-align: right;
  margin-bottom: 24px;
}
.Information-desc {
  width: 699px;
  font-size: 16px;
  color: #000000;
  line-height: 24px;
  text-align: right;
}
.img20 {
  width: 271px;
  height: 210px;
}
.page-title {
  margin-bottom: 60px;
  font-weight: bold;
  font-size: 40px;
  color: #000000;
  text-align: center;
}
.card {
  display: flex;
  padding: 0 360px;
  align-items: center;
  margin-bottom: 70px;
}
.card > div {
  display: flex;
  flex-direction: column;
}
.card img {
  width: 72px;
  height: 72px;
  margin-right: 38px;
}
.card-title {
  font-weight: bold;
  font-size: 20px;
  color: #000000;
  line-height: 30px;
  margin-bottom: 10px;
  font-size: 24px;
}
.card-desc {
  font-size: 16px;
  color: #000000;
  line-height: 26px;
}
.print-box {
  display: flex;
  justify-content: center;
  margin-bottom: 193px;
}
.print {
  width: 532px;
  height: 532px;
  box-sizing: border-box;
  border: 1px solid #ffd9b8;
  border-radius: 50%;
  padding: 101px;
  position: relative;
}
.nei {
  width: 330px;
  height: 330px;
  box-sizing: border-box;
  border-radius: 50%;
  background-color: #fe953a;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.nei-title {
  width: 302px;
  font-weight: bold;
  font-size: 46px;
  color: #000000;
  text-align: center;
  margin-bottom: 30px;
}
.nei-desc {
  font-weight: 400;
  font-size: 20px;
  color: #000000;
  text-align: center;
}
.info1 {
  position: absolute;
  display: flex;
  align-items: flex-start;
  left: -320px;
  text-align: right;
  width: 414px;
  top: 60px;
}
.info2 {
  position: absolute;
  display: flex;
  align-items: flex-start;
  right: -380px;
  text-align: right;
  width: 414px;
  top: 180px;
}
.info3 {
  position: absolute;
  display: flex;
  align-items: flex-start;
  left: -320px;
  text-align: right;
  width: 414px;
  bottom: 10px;
}
.num {
  width: 58px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  border-radius: 50%;
  background: linear-gradient(219deg, #ffca5d 0%, #fe953a 100%);
  font-weight: bold;
  font-size: 24px;
  color: #ffffff;
  margin-left: 40px;
  box-sizing: border-box;
}
.info2 .num {
  margin-left: 0;
  margin-right: 40px;
}
.info-title {
  margin-bottom: 14px;
  font-weight: bold;
  font-size: 20px;
  color: #000000;
}
.info-desc {
  font-size: 14px;
  color: #000000;
}
.Nuestra-box {
  display: flex;
  justify-content: center;
  margin-bottom: 100px;
}
.Nuestra {
  width: 1200px;
  height: 316px;
  background: #fff8f2;
  border-radius: 24px;
  padding: 64px 74px;
  box-sizing: border-box;
  position: relative;
}
.Nuestra-title {
  font-weight: bold;
  font-size: 40px;
  color: #000000;
  margin-bottom: 20px;
}
.Nuestra-desc {
  width: 515px;
  font-size: 17px;
  color: #000000;
  line-height: 24px;
}
.img23 {
  width: 156px;
  height: 364px;
  position: absolute;
  right: 218px;
  bottom: 69px;
  z-index: 2;
}
.img24 {
  width: 488px;
  height: 139px;
  position: absolute;
  bottom: 0;
  right: 60px;
  z-index: 1;
}
.Contanos {
  height: 495px;
  background: #fff8f2;
  box-sizing: border-box;
  padding: 90px 360px;
  position: relative;
}
.Contanos-title {
  font-weight: bold;
  font-size: 40px;
  text-align: center;
  margin-bottom: 50px;
}
.img25 {
  width: 50px;
  height: 44.28px;
}
.c-desc {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 50px;
}
.c-desc span {
  margin-left: 20px;
}
.Facebook {
  margin-left: 100px;
}
.Av {
  margin-left: 200px;
}
.img26 {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 321px;
  height: 495px;
  right: 268px;
}
</style>
